/**
 * Config compartida para /ar/invitacion y /exclusive-ar (tier VIP) — brand delfuocampo.
 * Precios y nombres desde env (Vercel); fallback a valores por defecto si no están definidos.
 *
 * Keys en Vercel:
 *   VITE_AR_INVITACION_STANDARD_PRICE   (ej. 29999)
 *   VITE_AR_INVITACION_VIP_PRICE        (ej. 49999)
 *   VITE_AR_INVITACION_STANDARD_PRODUCT_NAME  (opcional)
 *   VIP product name: fijo "Membresía exclusiva" (VITE_AR_INVITACION_VIP_PRODUCT_NAME ignorado)
 *   VITE_AR_INVITACION_STANDARD_SUBTITLE      (opcional, ej. "por mes")
 *   VITE_AR_INVITACION_VIP_SUBTITLE           (opcional, ej. "por mes · grupo + hablar conmigo")
 */

export const AR_INVITACION_CURRENCY = "ARS" as const;

const DEFAULT_STANDARD_PRICE = 29999;
const DEFAULT_VIP_PRICE = 49999;
const DEFAULT_STANDARD_PRODUCT_NAME = "Miembro Exclusivo";

/** Nombre fijo en UI, CTA y checkout Mercado Pago de /ar/invitacion. */
export const AR_INVITACION_MEMBERSHIP_NAME = "Membresía exclusiva";

export const AR_INVITACION_CTA_LABEL = AR_INVITACION_MEMBERSHIP_NAME;

function parsePrice(envVal: string | undefined, defaultVal: number): number {
  if (envVal === undefined || envVal === null) return defaultVal;
  const n = Number(String(envVal).trim());
  return Number.isFinite(n) && n > 0 ? Math.round(n) : defaultVal;
}

function parseProductName(envVal: string | undefined, defaultVal: string): string {
  const s = typeof envVal === "string" ? envVal.trim() : "";
  return s.length > 0 ? s : defaultVal;
}

/** Precio y nombre por plan. Valores desde env (Vercel) o defaults. */
export const AR_PLANS = {
  standard: {
    price: parsePrice(import.meta.env.VITE_AR_INVITACION_STANDARD_PRICE as string | undefined, DEFAULT_STANDARD_PRICE),
    productName: parseProductName(import.meta.env.VITE_AR_INVITACION_STANDARD_PRODUCT_NAME as string | undefined, DEFAULT_STANDARD_PRODUCT_NAME),
  },
  vip: {
    price: parsePrice(import.meta.env.VITE_AR_INVITACION_VIP_PRICE as string | undefined, DEFAULT_VIP_PRICE),
    productName: AR_INVITACION_MEMBERSHIP_NAME,
  },
} as const;

export type ArPlanTier = keyof typeof AR_PLANS;

/** Ruta + query para el flujo VIP (misma experiencia que /exclusive-ar con precio VIP). */
export const AR_VIP_EXCLUSIVE_PATH = "/exclusive-ar?tier=vip";

/** Subtítulo de la card Standard en /ar/invitacion (env o default). */
export const AR_PLAN_STANDARD_SUBTITLE =
  parseProductName(import.meta.env.VITE_AR_INVITACION_STANDARD_SUBTITLE as string | undefined, "por mes");

/** Subtítulo de la card VIP en /ar/invitacion (env o default). Debe coincidir con el mensaje de /exclusive-ar?tier=vip. */
export const AR_PLAN_VIP_SUBTITLE =
  parseProductName(import.meta.env.VITE_AR_INVITACION_VIP_SUBTITLE as string | undefined, "por mes · grupo + hablar conmigo");
